export default __webpack_public_path__ + "static/media/design_bg.af1d95bb.png";